import React from "react";
import ReactDOM from "react-dom";
import { App } from "App";
import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "state/reducers";
import * as serviceWorker from "serviceWorker";
import "index.css";

export const store = configureStore({
  reducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

ReactDOM.render(
  <React.StrictMode>
    <App store={store} />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
